import { render, staticRenderFns } from "./feature-section.vue?vue&type=template&id=c2da0414&scoped=true&"
import script from "./feature-section.vue?vue&type=script&lang=js&"
export * from "./feature-section.vue?vue&type=script&lang=js&"
import style0 from "./feature-section.vue?vue&type=style&index=0&id=c2da0414&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2da0414",
  null
  
)

export default component.exports